import { CombinedDocumentsMap, ImagesMap } from 'models';
import { isImage } from './entityType';
import { filterCombinedDocuments } from './filterCombinedDocuments';

export const filterImages = (documents: CombinedDocumentsMap): ImagesMap => {
  return filterCombinedDocuments(documents, isImage) as ImagesMap;
};
